// fetch and expand all user privileges into a final list.
export async function getUserEffectivePrivileges(
  userId,
  fetchUserPrivileges,
  fetchUserRoles,
  fetchRolePrivileges
) {
  // direct user privileges
  const privRes = await fetchUserPrivileges(userId);
  const directPrivileges = privRes?.data
    ? privRes.data.map((up) => up.privilege.name)
    : [];

  // user roles
  const rolesRes = await fetchUserRoles(userId);
  const roleIds = rolesRes ? rolesRes.map((r) => r.roleId) : [];

  // expand all user roles into privileges
  const allRolesPrivileges = await Promise.all(
    roleIds.map(async (roleId) => {
      const rolePrivs = await fetchRolePrivileges(roleId);

      if (!Array.isArray(rolePrivs?.data)) return [];

      return rolePrivs.data.map((p) => p.name);
    })
  );

  const rolePrivileges = allRolesPrivileges.flat();

  // merge and remove duplicates
  const merged = new Set([...directPrivileges, ...rolePrivileges]);

  return Array.from(merged);
}
